<div class="modal modal_size_744 modal__opened">
  <div class="modal__close icon icon-close" (click)="close()"></div>
  <div class="modal__container">
    <div class="modal__img">
      <div class="modal-img modal-img_name_gift modal-img_size_192"></div>
    </div>
    <div class="modal__title modal__title-mb12 h2" *ngIf="!privetPlus">{{ 'subscription-info-modal.title-privet' | translate }}</div>
    <div class="modal__title modal__title-mb12 h2" *ngIf="privetPlus">{{ 'subscription-info-modal.title-privet-plus' | translate }}</div>
    <div class="modal__text" *ngIf="!privetPlus">{{ ('subscription-info-modal.text-privet' + (subscriptionActive ? '-connected' : '')) | translate }}</div>
    <div class="modal__text" *ngIf="privetPlus">{{ ('subscription-info-modal.text-privet-plus' + (subscriptionActive ? '-connected' : '')) | translate }}</div>
    <div class="modal__subtext" *ngIf="privetPlus && !subscriptionActive" [innerHtml]="'subscription-info-modal.subtext-privet-plus' | translate"></div>
  </div>
  <div class="modal__buttons-row modal__buttons-mt40">
    <div class="button button_with_price" *ngIf="!privetPlus && !subscriptionActive" [innerHtml]="'subscription-info-modal.connect-privet' | translate"
         (click)="activateSubscription()"></div>
    <div class="button button_with_price" *ngIf="privetPlus && !subscriptionActive" [innerHtml]="'subscription-info-modal.connect-privet-plus' | translate"
         (click)="activateSubscription()"></div>
    <div class="button button_type_light" *ngIf="subscriptionActive" [innerHtml]="'subscription-info-modal.disconnect' | translate" (click)="deactivateSubscription()"></div>
  </div>
</div>
